import { requestBuilder } from '../../http/RequestBuilder';

export interface GuidanceSessionTranscriptResponse {
    transcript: string;
    s3Key: string;
}

export const useGetGuidanceSessionTranscript = requestBuilder.query<
    GuidanceSessionTranscriptResponse | null,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/guidance-session/${id}/transcript`,
    queryKey: ({ id }) => `guidanceSessionTranscript/${id}`,
});
